import {UpgradeSource} from '../../../models/AnalyticsModels';

// Here, not layout/: ModalsModule is imported widely and layout/ is the shell.

export interface TopbarNavLink {
    label: string;
    route: string;
    icon: string;
    authOnly: boolean;
}

export const TOPBAR_NAV_LINKS: TopbarNavLink[] = [
    {label: 'Flight Deals', route: '/dashboard', icon: 'ph-airplane-tilt', authOnly: true},
    {label: 'Hotels', route: '/hotels', icon: 'ph-buildings', authOnly: false},
    {label: 'Perks', route: '/member-perks', icon: 'ph-gift', authOnly: true},
    {label: 'Rewards', route: '/rewards', icon: 'ph-trophy', authOnly: true},
    {label: 'Trips', route: '/trips', icon: 'ph-suitcase-simple', authOnly: true},
];

export const MOBILE_TAB_LINKS: TopbarNavLink[] = [
    {label: 'Flight Alerts', route: '/dashboard', icon: 'ph-airplane-tilt', authOnly: true},
    {label: 'Hotels', route: '/hotels', icon: 'ph-buildings', authOnly: false},
    {label: 'Trips', route: '/trips', icon: 'ph-suitcase-simple', authOnly: true},
    {label: 'Rewards', route: '/rewards', icon: 'ph-trophy', authOnly: true},
    {label: 'Perks', route: '/member-perks', icon: 'ph-gift', authOnly: true},
];

export const MOBILE_MORE_LINKS: TopbarNavLink[] = [
    {label: 'Perks', route: '/member-perks', icon: 'ph-gift', authOnly: true},
    {label: 'Flight Deal Alerts', route: '/dashboard', icon: 'ph-bell', authOnly: true},
];

export const MOBILE_MORE_SIGNED_OUT_LINKS: TopbarNavLink[] = [
    {label: 'Log in', route: '/login', icon: 'ph-sign-in', authOnly: false},
    {label: 'Join for free', route: '/signup/14daytrialorganic', icon: 'ph-user-plus', authOnly: false},
];

// Frozen because every upgrade navigation hands the router this one object.
export const UPGRADE_QUERY_PARAMS = Object.freeze({
    upgrade_source: UpgradeSource.DashboardMenuBar,
    upgrade_campaign: '1_14_day_trial',
    upgrade_cohort: '2026',
});
